<template>
  <div class="product-info">
    <img v-if="$props.image" :src="$props.image" alt="">
    <div class="product-info-desc">
      <span v-if="$props.brand" class="product-info-desc-brand">{{ $props.brand }}</span>
      <span class="product-info-desc-name"
            :class="{'tariff': !$props.image && !$props.brand}">{{ $props.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-info',
  props: {
    image: String,
    brand: String,
    name: String
  }
}
</script>

<style lang="scss" scoped>
.product-info {
  display: flex;
  flex: 0 0 calc(100% - 15rem);

  img {
    display: none;
    height: 6rem;

    @media (map_get($breakpoints, sm)) {
      display: block;
    }
  }
}

.product-info-desc {
  margin-left: .8rem;
}

.product-info-desc-brand {
  display: block;
  margin-bottom: .2rem;
  font-size: 1.2rem;
  text-transform: uppercase;
}

.product-info-desc-name {
  display: block;
  font-weight: 500;

  &.tariff {
    padding: 1.6rem 0;
    color: $mtel-red;
    font-size: 1.8rem;

    @media (map_get($breakpoints, sm)) {
      font-size: 2rem;
    }
  }
}
</style>
